import React, { useMemo } from 'react';
import { DefaultEditorOptions, RichTextInput } from 'ra-input-rich-text';
import { Placeholder } from '@tiptap/extension-placeholder';
import { Validator } from 'react-admin';
import { SxProps } from '@mui/material';

const CommentInput = ({
  source,
  validate,
  placeholder,
  helperText,
  sx,
}: {
  source: string;
  validate?: Validator | Validator[];
  placeholder?: string;
  helperText?: string | false | React.ReactElement;
  sx?: SxProps;
}) => {
  const editorOptions = useMemo(() => ({
    ...DefaultEditorOptions,
    extensions: [
      ...(DefaultEditorOptions.extensions ?? []),
      Placeholder.configure({
        placeholder: placeholder ?? 'Write your comment...',
      }),
    ],
  }), [placeholder]);

  return (
    <RichTextInput
      source={source}
      sx={{
        ...sx,
        '& > .MuiStack-root': {
          height: '100%',
        },
        '& .RaRichTextInput-editorContent': {
          flexGrow: 1,
        },
        '& .tiptap': {
          minHeight: 96,
          height: '100%',
        },
        '& .tiptap p.is-editor-empty:first-child::before': {
          color: '#adb5bd',
          content: 'attr(data-placeholder)',
          float: 'left',
          height: 0,
          pointerEvents: 'none',
        },
      }}
      label={false}
      validate={validate}
      helperText={helperText}
      editorOptions={editorOptions}
    />
  );
};

export default CommentInput;
